export const aspectRatios = Object.freeze({
  regular: Object.freeze({ height: 3, width: 3.9, }),
  headline: Object.freeze({ height: 9, width: 15.48, }),
  landscape: Object.freeze({ height: 9, width: 20.79, }),
  square: Object.freeze({ height: 1, width: 1, }),
  vertical: Object.freeze({ height: 20, width: 17, }),
  belgrade: Object.freeze({ height: 1, width: 3.18, }),
});
